import React from 'react';
import AccountUserRankList from '../AccountUserRankList';
import RankSearchBox from '../common/RankSearchBox';

const AccountUserRankListWrap = (props) => {
  const { accountUserRankList, getList, getExcelDownload } = props;

  return (
    <div className="account-user-list-wrap">
      <RankSearchBox getList={getList} />

      {/* 유저 랭킹 리스트 */}
      <AccountUserRankList
        accountUserRankList={accountUserRankList}
        getList={getList}
        getExcelDownload={getExcelDownload}
      />
    </div>
  );
};

export default AccountUserRankListWrap;
